import { Link } from "react-router-dom";
import type { Work } from "@/mocks/movies";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  const isSeries = work.type === "tvseries";

  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 hover:bg-background-50"
    >
      <div className="relative w-full overflow-hidden" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} 韩国伦理影视作品封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-900/85 px-2 py-1 text-[11px] font-semibold text-background-50 backdrop-blur-sm">
          {isSeries ? "电视剧" : "电影"}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500/95 px-2 py-1 text-[11px] font-bold text-background-50 backdrop-blur-sm">
          <i className="ri-star-fill text-[10px]" />
          {work.rating.toFixed(1)}
        </span>
        <span className="absolute inset-x-0 bottom-0 flex items-center gap-1 bg-gradient-to-t from-primary-950/85 to-transparent px-2.5 py-2 text-[11px] font-medium text-background-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <i className="ri-play-circle-line text-sm" />
          查看作品详情
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="line-clamp-1 font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {work.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{work.originalTitle}</p>
        <div className="mt-2 flex flex-wrap items-center gap-1.5">
          <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900">
            {work.genres[0]}
          </span>
          <span className="text-[11px] text-foreground-500">{work.year}</span>
          <span className="text-[11px] text-foreground-300">·</span>
          <span className="text-[11px] text-foreground-500">{work.duration}</span>
        </div>
      </div>
    </Link>
  );
}